import * as React from "react";
import Link from "@mui/material/Link";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

export default function AppBreadcrumbs({ homeLabel = "Accueil", default_home_link = "/", defaultTitle = "FID candidature", display = true ,sx}) {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  React.useEffect(()=>{
    document.title = defaultTitle + (pathnames[0] ? " | " + String(pathnames[0]).charAt(0).toUpperCase() + String(pathnames[0]).slice(1) : "");
  },[pathnames])
  // Limiter à 4 niveaux de hiérarchie maximum
  const limitedPathnames = pathnames.slice(0, 4);

  // Si le nombre de pathnames dépasse la limite, afficher "..." au milieu
  const showEllipsis = pathnames.length > limitedPathnames.length;
  const displayedPathnames = showEllipsis
    ? [limitedPathnames[0], "...", limitedPathnames[limitedPathnames.length - 1]]
    : limitedPathnames;

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ ...sx, ml:1.5, my: 1, display: display ? "flex" : "none" }} >
      <Link component={RouterLink} to={default_home_link} underline="hover" color="inherit">
        {homeLabel}
      </Link>
      {displayedPathnames.map((value, index) => {
        if (value === "...") {
          return (
            <Typography key="ellipsis" color="text.primary">
              ...
            </Typography>
          );
        }
        // Calculer l'index réel dans pathnames pour générer le bon lien
        const realIndex = showEllipsis
          ? index === 0
            ? 0
            : pathnames.length - 1
          : index;
        const to = `/${pathnames.slice(0, realIndex + 1).join("/")}`;
        const isLast = index === displayedPathnames.length - 1;

        return isLast ? (
          <Typography key={to} color="text.primary">
            {value}
          </Typography>
        ) : (
          <Link
            key={to}
            component={RouterLink}
            to={to}
            underline="hover"
            color="inherit"
          >
            {value}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
